/* eslint-disable no-bitwise */

const num = ' unu doi trei patru cinci sase sapte opt noua zece unsprezece douasprezece treisprezece paisprezece cincisprezece saisprezece saptesprezece optsprezece nouasprezece'.split(' ');
const tens = 'douazeci treizeci patruzeci cincizeci saizeci saptezeci optzeci nouazeci '.split(' ');

export default function convertNumberInWords(n) {
  if (n < 20) return num[n];
  const digit = n % 10;
  if (n < 100) return tens[~~(n / 10) - 2] + (digit ? ` si ${num[digit]}` : '');
  if (n < 1000) return `${num[~~(n / 100)]} sute${n % 100 === 0 ? '' : ` ${convertNumberInWords(n % 100)}`}`;
  return `${convertNumberInWords(~~(n / 1000))} mii${n % 1000 !== 0 ? ` ${convertNumberInWords(n % 1000)}` : ''}`;
}
